import axiosInstance from "../../axiosInstance";

const createArchive = async (data) => {
  try {
    const res = await axiosInstance.post(`/api/archive/create`, data);

    if (res.status === 201) {
      return res.data;
    } else {
    }
  } catch (error) {}
};

export default createArchive;
